import cn from 'classnames'
import React from 'react'

import styles from './SectionItem.module.scss'

interface SectionItemButtonProps extends React.HTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode
  selected?: boolean
  hovered?: boolean
  disabled?: boolean
}

function SectionItemButton(
  { children, className, selected, hovered, disabled, ...props }: SectionItemButtonProps,
  ref: React.ForwardedRef<HTMLButtonElement>
) {
  return (
    <button
      ref={ref}
      type="button"
      disabled={disabled}
      className={cn(
        styles.sectionItemButton,
        hovered && styles.hovered,
        selected && styles.selected,
        disabled && styles.disabled,
        className
      )}
      {...props}
    >
      {children}
    </button>
  )
}

export default React.forwardRef<HTMLElement, SectionItemButtonProps>(SectionItemButton) as typeof SectionItemButton
